import { harSupabase } from "./supabase";

/**
 * Sier fra at regi skriver en loggpost akkurat naa.
 *
 * KRINGKASTES, LAGRES ALDRI. En skriveindikator er sann i to sekunder og
 * uinteressant etterpaa. Skrevet til basen ville den blitt en rad per
 * tastetrykk i en logg som er append-only.
 *
 * DETTE ER IKKE LOGGING, og det maa det ikke bli. Teksten sendes ALDRI —
 * bare at det skrives, og i hvilken oekt. Et utkast er ikke en loggpost
 * foer regi har sagt at det er det, og halvskrevne setninger fra sett skal
 * ingen steder.
 *
 * SENDES SOM EN POST, IKKE OVER EN WEBSOCKET.
 *
 * «En websocket som ligger og venter i en jakkelomme er feil pris» staar i
 * appen fra foer, og det gjelder her ogsaa — en skriveindikator er ikke
 * verdt en aapen forbindelse. Realtime tar imot kringkastinger over HTTP,
 * og da er dette én liten foresporsel annethvert sekund mens det tastes,
 * og ingenting resten av dagen.
 *
 * Det loeser ogsaa et hastverksproblem: en kanal man nettopp har aapnet er
 * ikke klar ennaa, og de foerste tastetrykkene ville falt paa gulvet.
 *
 * KREVER INGENTING. Ingen kvittering, ingen avslutningsmelding. Faller
 * dekningen, slutter prikkene aa komme og forsvinner hos redaktoeren av seg
 * selv — se `skrivende.ts` paa nettflata.
 */

/* Sendes ikke oftere enn dette mens det tastes. Levetiden hos mottakeren er
   fire sekunder, saa to sekunder holder prikkene i live med god margin —
   uten at hvert tastetrykk blir en foresporsel. */
const TAKT_MS = 2000;

const url = import.meta.env["VITE_SUPABASE_URL"];
const anon = import.meta.env["VITE_SUPABASE_ANON_KEY"];

let sist = 0;

export function skriver(
  produksjonId: string, opptaksdag: string, oektId: string | null,
): void {
  if (!harSupabase || oektId === null) return;
  if (produksjonId === "" || produksjonId === "privat") return;
  if (!navigator.onLine) return;

  const naa = Date.now();
  if (naa - sist < TAKT_MS) return;
  sist = naa;

  /* Ingen `await` og ingen feilhaandtering: kommer den ikke fram, uteblir
     prikkene. Det er hele konsekvensen. */
  void fetch(`${String(url)}/realtime/v1/api/broadcast`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      apikey: String(anon),
      Authorization: `Bearer ${String(anon)}`,
    },
    body: JSON.stringify({
      messages: [{
        topic: `skriver:${produksjonId}:${opptaksdag}`,
        event: "skriver",
        payload: { oektId },
      }],
    }),
  }).catch(() => { /* uten dekning blir det ingen prikker. Det er greit. */ });
}
